


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const getLawDocsDetailReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.GET_LAW_DOCS_DETAIL:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.GET_LAW_DOCS_DETAIL_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.GET_LAW_DOCS_DETAIL_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
